import { createAllIdsReducer } from 'store/redux';

import { FETCH_INTEGRATION_CONFIGS_SUCCESS, FETCH_INTEGRATION_CONFIG_SUCCESS } from 'types/integrations';

export default createAllIdsReducer({
  key: 'integrationConfig',
  types: [FETCH_INTEGRATION_CONFIG_SUCCESS, FETCH_INTEGRATION_CONFIGS_SUCCESS],
});
